import React from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { ChevronLeft } from "@mui/icons-material";
import BranchSection from "./BranchSection";
import TimerDisplay from "./RefreshTimerDisplay";
import UserMenu from "./UserMenu";

const drawerWidth = 320;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  backgroundColor: theme.palette.primary.main,
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("md")]: {
      width: "100%",
      zIndex: theme.zIndex.drawer - 1,
    },
  }),
}));

const MenuDiv = styled("div")(({ theme, mobileOpen }) => ({
  display: "none",
  [theme.breakpoints.down("md")]: {
    display: mobileOpen ? "none" : "block",
  },
}));

const DesktopMenuDiv = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const CompanyDiv = styled("div")(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "700",
  letterSpacing: "1px",
  "& span": {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: "600",
  },
}));

export default function Navbar({
  open,
  mobileOpen,
  onDrawerToggle,
  onMobileDrawerOpen,
}) {
  const loginData = localStorage.getItem("user");
  const loginValue = JSON.parse(loginData);

  return (
    <AppBar position="fixed" open={false}>
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <DesktopMenuDiv>
          <IconButton onClick={onDrawerToggle}>
            {open ? (
              <ChevronLeft fontSize="large" style={{ color: "#fff" }} />
            ) : (
              <MenuIcon fontSize="large" style={{ color: "#fff" }} />
            )}
          </IconButton>
          <BranchSection />
        </DesktopMenuDiv>

        <MenuDiv mobileOpen={mobileOpen}>
          <IconButton onClick={onMobileDrawerOpen}>
            <MenuIcon fontSize="large" style={{ color: "#fff" }} />
          </IconButton>
        </MenuDiv>

        <CompanyDiv>
          {loginValue?.company_name || "SSS Auto"}
          <TimerDisplay />
        </CompanyDiv>

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}
